import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Point 单一数字端点
 */
import { getDefaultElementOffset } from '@tencent/glue-util-boundary';
import { Emitter } from '@tencent/glue-util-emitter';
import { AxisType } from '../enum';
export var Point = /*#__PURE__*/function (_Emitter) {
  _inherits(Point, _Emitter);

  var _super = _createSuper(Point);

  function Point(region, type, name) {
    var _this;

    _classCallCheck(this, Point);

    _this = _super.call(this); // 实际坐标偏移量，实际坐标是一个(0, 0) ->(x.length, y.length)的封闭连续区域

    _this.offset = getDefaultElementOffset(); // 是否在拖拽中

    _this.dragging = false;
    _this.region = region;
    _this.type = type;
    _this.name = name;
    return _this;
  } // 坐标轴的名称


  _createClass(Point, [{
    key: "getPointName",
    value: function getPointName() {
      return this.name;
    } // 获取接点类型

  }, {
    key: "getPointType",
    value: function getPointType() {
      return this.type;
    } // 获取所属坐标轴

  }, {
    key: "getAxis",
    value: function getAxis(type) {
      return this.region.getAxis(type);
    } // 获取所属区域

  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    } // 获取Offset

  }, {
    key: "getOffset",
    value: function getOffset() {
      return this.offset;
    } // 获取端点的当前值

  }, {
    key: "getPointValue",
    value: function getPointValue() {
      return this.region.getPointValue(this.name);
    } // 向上更的值

  }, {
    key: "setPointValue",
    value: function setPointValue(value, virtual) {
      this.region.setPointValue(this.name, value, virtual);
    } // 获取拖拽状态

  }, {
    key: "getDragging",
    value: function getDragging() {
      return this.dragging;
    } // 设置拖拽中状态

  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      this.dragging = dragging;
      this.region.setDragging(dragging);
    } // 刷新端点组件

  }, {
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    } // 更新端点的大小

  }, {
    key: "updatePointValue",
    value: function updatePointValue() {
      var _this$getPointValue = this.getPointValue(),
          x = _this$getPointValue.x,
          y = _this$getPointValue.y;

      this.offset = {
        x: this.getAxis(AxisType.HORIZONTAL).getValueOffset(x) || 0,
        y: this.getAxis(AxisType.VERTICAL).getValueOffset(y) || 0
      };
      this.repaint();
    }
  }, {
    key: "updateRealOffset",
    value: function updateRealOffset(start, end) {
      this.offset = this.calcNewOffsetByType(start, end);
      var virtual = this.dragging;
      var value = this.calcOffsetPrecisionValue();
      var old = {
        x: this.getPrecisionValue(AxisType.HORIZONTAL),
        y: this.getPrecisionValue(AxisType.VERTICAL)
      };
      var xChangeAndValid = value.x !== old.x && this.getAxis(AxisType.HORIZONTAL).isValidValue(+value.x);
      var yChangeAndValid = value.y !== old.y && this.getAxis(AxisType.VERTICAL).isValidValue(+value.y);

      if (xChangeAndValid || yChangeAndValid) {
        this.setPointValue({
          x: xChangeAndValid ? +value.x : +old.x,
          y: yChangeAndValid ? +value.y : +old.y
        }, virtual);
      } else if (!virtual) {
        // 刷新一下值
        this.setPointValue({
          x: +old.x,
          y: +old.y
        });
      }

      this.region.repaint();
    }
    /**
     * 获取精度计算后的结果
     */

  }, {
    key: "getOffsetPrecisionValue",
    value: function getOffsetPrecisionValue() {
      var _this$getPointValue2 = this.getPointValue(),
          x = _this$getPointValue2.x,
          y = _this$getPointValue2.y;

      return {
        x: this.getAxis(AxisType.HORIZONTAL).formatPrecisionValue(x),
        y: this.getAxis(AxisType.VERTICAL).formatPrecisionValue(y)
      };
    }
    /**
     * 获取精度计算后的结果
     */

  }, {
    key: "getPrecisionValue",
    value: function getPrecisionValue(type) {
      var _this$getPointValue3 = this.getPointValue(),
          x = _this$getPointValue3.x,
          y = _this$getPointValue3.y;

      var value = type === AxisType.HORIZONTAL ? x : y;
      return this.getAxis(type).formatPrecisionValue(value);
    }
  }, {
    key: "setPrecisionValue",
    value: function setPrecisionValue(type, value, virtual) {
      var val = +value;
      var axis = this.getAxis(type);

      var _this$getPointValue4 = this.getPointValue(),
          x = _this$getPointValue4.x,
          y = _this$getPointValue4.y;

      if (!axis.isValidValue(val)) {
        return false;
      }

      this.setPointValue({
        x: type === AxisType.HORIZONTAL ? val : x,
        y: type === AxisType.VERTICAL ? val : y
      }, virtual);
      return true;
    }
  }, {
    key: "upStep",
    value: function upStep(type) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (Math.floor(stepCount) !== stepCount) {
        throw new Error("stepCount should be int, but receive ".concat(stepCount));
      }

      var _this$getPointValue5 = this.getPointValue(),
          x = _this$getPointValue5.x,
          y = _this$getPointValue5.y;

      var axis = this.getAxis(type);
      var pv = axis.stepPrecisionValue(type === AxisType.HORIZONTAL ? x : y, stepCount);
      this.setPrecisionValue(type, pv);
    }
  }, {
    key: "downStep",
    value: function downStep(type) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (Math.floor(stepCount) !== stepCount) {
        throw new Error("stepCount should be int, but receive ".concat(stepCount));
      }

      var _this$getPointValue6 = this.getPointValue(),
          x = _this$getPointValue6.x,
          y = _this$getPointValue6.y;

      var axis = this.getAxis(type);
      var pv = axis.stepPrecisionValue(type === AxisType.HORIZONTAL ? x : y, -stepCount);
      this.setPrecisionValue(type, pv);
    } // 计算运动位置

  }, {
    key: "calcNewOffsetByType",
    value: function calcNewOffsetByType(start, end) {
      var x = end.x,
          y = end.y;
      var offset = {
        x: Math.min(this.getAxis(AxisType.HORIZONTAL).getAxisLength(), Math.max(0, x)),
        y: Math.min(this.getAxis(AxisType.VERTICAL).getAxisLength(), Math.max(0, y))
      };
      var canXChange = this.type & 2;
      var canYChange = this.type & 8;
      return {
        x: canXChange ? offset.x : start.x,
        y: canYChange ? offset.y : start.y
      };
    }
    /**
     * 获取精度计算后的结果
     */

  }, {
    key: "calcOffsetPrecisionValue",
    value: function calcOffsetPrecisionValue() {
      var _this$offset = this.offset,
          x = _this$offset.x,
          y = _this$offset.y;
      return {
        x: this.getAxis(AxisType.HORIZONTAL).getOffsetPrecisionValue(x),
        y: this.getAxis(AxisType.VERTICAL).getOffsetPrecisionValue(y)
      };
    }
  }]);

  return Point;
}(Emitter);